import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { quizApi, StartQuizDto, SubmitAnswerDto } from '../lib/api/quiz';

export const QUIZ_QUERY_KEY = 'quiz';

export function useProgress(courseId: number) {
  return useQuery({
    queryKey: [QUIZ_QUERY_KEY, courseId, 'progress'],
    queryFn: () => quizApi.getProgress(courseId),
    enabled: !!courseId,
  });
}

export function useSessionResults(sessionId: string) {
  return useQuery({
    queryKey: [QUIZ_QUERY_KEY, 'session', sessionId],
    queryFn: () => quizApi.getSessionResults(sessionId),
    enabled: !!sessionId,
  });
}

export function useStartQuiz() {
  return useMutation({
    mutationFn: ({ courseId, dto }: { courseId: number; dto: StartQuizDto }) =>
      quizApi.startSession(courseId, dto),
  });
}

export function useSubmitAnswer() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (dto: SubmitAnswerDto) => quizApi.submitAnswer(dto),
    onSuccess: () => {
      // Invalidate progress queries after answer submission
      queryClient.invalidateQueries({ queryKey: [QUIZ_QUERY_KEY] });
    },
  });
}
